/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ConfigService } from './../../services/config.service';
import { LmsEventDetails } from './../../model/lms-event-details.model';
import { LmsMenuService } from './../../services/lms-menu.service';
import { MenuItem } from './../../model/menu-item.model';
import { Router } from '@angular/router';
import { Tab } from './../../model/tab.model';
import { TabService } from './../../services/tab.service';

/**
 * This side navigation component created for all menu items
 * which are shown in left side menu.
 * @export
 * @class LmsSideNavigationComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-side-navigation',
  templateUrl: './lms-side-navigation.component.html',
  styleUrls: ['./lms-side-navigation.component.scss']
})

export class LmsSideNavigationComponent implements OnInit, OnDestroy {

  menuItems: MenuItem[] = [];
  selectedType: string;
  tabs: Tab[];
  @Input() currentUrl;
  @Input() editMode: Boolean;
  tabLevel: number;
  tabSubscription: any;

  /**
   * Creates an instance of LmsMenuService, TabService
   * @param {LmsMenuService} lmsMenuService
   * @param {TabService} tabService
   * @memberOf LmsSideNavigationComponent
   */
  constructor(private lmsMenuService: LmsMenuService,
    private tabService: TabService, private router: Router,
    private configService: ConfigService) {
    this.tabLevel = this.configService.getConfigData().tabIndex.sideNavigation;
  }

  /**
   * This method invoked when component is load and it initialize menu items
   * from LmsMenuService, tabs for selected menu item, selected tab and type.
   * @memberOf LmsSideNavigationComponent
   */
  ngOnInit() {
    this.menuItems = this.lmsMenuService.getMenuItems().map((data) => { return <MenuItem>(data); });
    this.tabSubscription = this.tabService.tabStoreObservable.subscribe(data => {
      this.tabs = data;
      const selectedTab = data.find((tab) => { return tab.selected; });
      this.selectedType = selectedTab ? selectedTab.type : this.selectedType;
    });
  }

  /**
   * This method invoked when switching between the left side menu items.
   * @param {LmsEventDetails} lmsEventDetails
   * @memberOf LmsSideNavigationComponent
   */
  lmsEventHandler(lmsEventDetails: LmsEventDetails) {
    this.tabService.notifyChange(lmsEventDetails);
  }

  /**
   * Life cycle hook for clean up
   * @memberOf LmsSideNavigationComponent
   */
  ngOnDestroy() {
    this.tabSubscription.unsubscribe();
  }
}
